import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import ObjectType from './../models/ObjectType';

const initialState = {
    isFetching: false,
    isFetchingUpdate: false,
    objectTypes: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        objectType: new ObjectType()
    },
    allObjectType: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.OBJECT_TYPE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.OBJECT_TYPE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                objectTypes: action.objectTypes.result,
                pageSize: action.objectTypes.pageSize,
                pageIndex: action.objectTypes.pageIndex,
                totalCount: action.objectTypes.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.OBJECT_TYPE_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.OBJECT_TYPE_ALL_SUCCESS:
            return { ...state, isFetching: false, allObjectType: action.objectTypes };
        case Types.OBJECT_TYPE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, objectTypes: [] };
        case Types.OBJECT_TYPE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.OBJECT_TYPE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    objectType: action.objectType
                }
            };
        case Types.OBJECT_TYPE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.OBJECT_TYPE_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.OBJECT_TYPE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.OBJECT_TYPE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.OBJECT_TYPE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.OBJECT_TYPE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.OBJECT_TYPE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.OBJECT_TYPE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.OBJECT_TYPE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.OBJECT_TYPE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.OBJECT_TYPE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default:
            return state
    }
}
